import { useSuspenseQueries } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import type { WeeklyStreakWidgetContent } from '../components/WeeklyStreakWidget'
import { exerciseStatsQueryOptions } from '../../../queries/activity-queries'
import {
  exerciseGoalQueryOptions,
  exerciseWeekQueryOptions,
} from '../../../queries/exercise-queries'
import { getCurrentYearWeek } from '../../../utils/year-week'

export function useWeeklyStreakWidgetContent(): WeeklyStreakWidgetContent {
  const { t } = useTranslation(['dashboard'])
  const currentYearWeek = getCurrentYearWeek()

  const [exerciseWeekCountQuery, exerciseGoalQuery, exerciseStatsQuery] =
    useSuspenseQueries({
      queries: [
        exerciseWeekQueryOptions(currentYearWeek),
        exerciseGoalQueryOptions(currentYearWeek),
        exerciseStatsQueryOptions,
      ],
    })

  const progress = exerciseWeekCountQuery.data.length
  const streak = exerciseStatsQuery.data.streak
  const exerciseGoal = exerciseGoalQuery.data

  return {
    exercisesLabel: t('dashboard:weekly_widget_exercises_label'),
    exercisesValue: t('dashboard:weekly_widget_exercises_value_completed', {
      count: progress,
    }),
    exerciseGoalLabel: t('dashboard:weekly_widget_exercise_goal_label'),
    exerciseGoalValue: t('dashboard:weekly_widget_exercise_goal_value', {
      count: exerciseGoal,
    }),
    streakLabel: t('dashboard:weekly_widget_streak_label'),
    streakValue: t('dashboard:weekly_widget_streak_value', {
      count: streak,
    }),
  }
}
